// Decode the payload of a Google ID token (JWT) to read the user's profile.
// The token is three base64url parts separated by dots; the middle is the JSON
// payload with name / picture / email.
function decodeJwt(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    const p = JSON.parse(json)
    return { name: p.name || '', picture: p.picture || '', email: p.email || '' }
  } catch (e) {
    return { name: '', picture: '', email: '' }
  }
}

export default {
  state: {
    authenticated: null,
    token: localStorage.getItem('googleToken') || null,
    user: JSON.parse(localStorage.getItem('googleUser') || 'null'),
  },
  actions: {
    // Restore sign-in state on page load.
    isAuthenticated(ctx) {
      const token = localStorage.getItem('googleToken')
      if (localStorage.getItem('isAuthenticated') && token) {
        const user = JSON.parse(localStorage.getItem('googleUser') || 'null') || decodeJwt(token)
        ctx.commit('updateToken', token)
        ctx.commit('updateUser', user)
        ctx.commit('updateAuthenticated', true)
      } else {
        ctx.commit('updateAuthenticated', false)
      }
    },
    // Called when Google hands us a fresh ID token.
    setGoogleAuth(ctx, token) {
      const user = decodeJwt(token)
      localStorage.setItem('isAuthenticated', true)
      localStorage.setItem('googleToken', token)
      localStorage.setItem('googleUser', JSON.stringify(user))
      ctx.commit('updateToken', token)
      ctx.commit('updateUser', user)
      ctx.commit('updateAuthenticated', true)
    },
    signOutGoogle(ctx) {
      localStorage.removeItem('isAuthenticated')
      localStorage.removeItem('googleToken')
      localStorage.removeItem('googleUser')
      ctx.commit('updateToken', null)
      ctx.commit('updateUser', null)
      ctx.commit('updateAuthenticated', false)
    },
  },
  mutations: {
    updateAuthenticated(state, data) {
      state.authenticated = data
    },
    updateToken(state, data) {
      state.token = data
    },
    updateUser(state, data) {
      state.user = data
    },
  },
  getters: {
    getAuthenticated(state) {
      return state.authenticated
    },
    getToken(state) {
      return state.token
    },
    getUser(state) {
      return state.user
    },
  },
}
